import { render, staticRenderFns } from "./bcheader.vue?vue&type=template&id=4f1af395&scoped=true&"
import script from "./bcheader.vue?vue&type=script&lang=js&"
export * from "./bcheader.vue?vue&type=script&lang=js&"
import style0 from "./bcheader.vue?vue&type=style&index=0&id=4f1af395&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1af395",
  null
  
)

export default component.exports